import {Image} from '@sportngin/se-commerce-sdk/models/clare';
import {Bundle, Product} from '../../../models/clare';

export type ProductTableRow = Product | Bundle;

export const getTableRowId = (row: ProductTableRow | undefined): string | undefined =>
  row?.id !== undefined && row?.id !== null ? String(row.id) : undefined;

export const getTableRowName = (row: ProductTableRow | undefined): string => row?.name ?? '';

export const getTableRowImages = (row: ProductTableRow | undefined): Image[] | undefined => {
  if (row?.display_metadata?.images?.length) {
    return row.display_metadata.images;
  }

  if (row && 'image_url' in row && row.image_url) {
    return [{src: row.image_url, alt: row.name ?? ''}];
  }

  return undefined;
};

export const isTableRowActive = (row: ProductTableRow | undefined): boolean => row?.active ?? false;

export const getTableRowPrice = (row: ProductTableRow | undefined): number | undefined => {
  if (!row) {
    return undefined;
  }

  if ('price' in row && row.price !== undefined && row.price !== null) {
    return Number(row.price);
  }

  if ('price_cents' in row && row.price_cents !== undefined && row.price_cents !== null) {
    return Number(row.price_cents) / 100;
  }

  return undefined;
};
